import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    message: {
        'menu_title': '盛大金业',
        'menu_home': '首页',
        'menu_about_us': '关于我们',
        'menu_plat_advant': '平台优势',
        'menu_product_introduct': '产品介绍',
        'menu_latest_news': '最新资讯',
        'menu_open_account': '网上开户',
        'menu_process_info': '流程资料',
        'menu_contact_us': '联络我们',
        'menu_second_nav_1': '公司简介',
        'menu_second_nav_2': '公司奖项',
        'menu_second_nav_3': '公司资质',
        'menu_second_nav_4': '产品优势',
        'menu_second_nav_5': '存取优势',
        'menu_second_nav_6': '信誉优势',
        // 'menu_second_nav_7': '会员系统',
        'menu_second_nav_8': '现货黄金',
        'menu_second_nav_9': '现货白银',
        'menu_second_nav_10': '人民币公斤条',
        'menu_second_nav_11': '交易细则',
        'menu_second_nav_13': '公司公告',
        'menu_second_nav_14': '经济数据',
        'menu_second_nav_15': '每日汇率',
        'menu_second_nav_16': '经济新闻',
        'menu_second_nav_17': '专业评论',
        'menu_second_nav_18': '公司活动',
        'menu_second_nav_19': '开立真实账户',
        'menu_second_nav_20': '开立真实账户流程',
        'menu_second_nav_22': '存款流程',
        'menu_second_nav_23': '在线取款流程',
        'menu_second_nav_24': '国内卡优惠',
        'menu_second_nav_25': '下载交易软件',
        'menu_second_nav_28': '联络资料',
        'menu_second_nav_29': '即时开户',
        'menu_second_nav_30': '在线客服',
        'menu_second_nav_31': '官方微信',
        'menu_second_nav_32': '软件下载',
        'menu_online_transat': '线上交易',
        'menu_real_account': '开立真实账户',
        'menu_simulat_transat': '模拟交易',
        'menu_simulat_account': '开立模拟账户',
        'menu_dowan_trad_soft': '下载模拟交易软件',
        'menu_simulat_href': 'https://dwebt.sdggex.com:21420/demo/regdemo_sc.asp',
    },
    brandInfo: {
        'brand_menu_title_1': '品牌优势',
        'brand_menu_title_2': '开户流程',
        'brand_title_1': '低门槛',
        'brand_title_2': '高杠杆',
        'brand_title_3': '双向交易',
        'brand_title_4': '公平货币兑换',
        'brand_title_5': '交易平台迅速及稳定',
        'brand_title_6': '投资便捷',
        'brand_title_7': '24小时取款',
        'brand_title_8': '信心保证',
        'brand_title_9': '交易公平、公正、公开',
        'brand_title_10': '存款即时到帐',
        'brand_dec_text_1': '最低可交易0.1手，资金低',
        'brand_dec_text_2': '资金少，高杠杆，以小博大',
        'brand_dec_text_3': '黄金、白银可做多或做空价格上涨可做多盈利',
        'brand_dec_text_4': '按照银行公布的货币兑换率',
        'brand_dec_text_5': '盛大交易平台稳定，交易迅速及易学易用',
        'brand_dec_text_6': '盛大交易平台24小时随时交易',
        'brand_dec_text_7': '客户可随时透过完善的网上用户中心提取',
        'brand_dec_text_8': '香港金银贸易场会员',
        'brand_dec_text_9': '交易平台的所有订单价格由国际市场价格，确保公平公正',
        'brand_dec_text_10': '24小时在线入金，即时入账到盛大交易账户',
        'process_steps_title_1': '第1步：提交资料',
        'process_steps_title_2': '第2步：系统审核',
        'process_steps_title_3': '第3步：开户通知',
        'process_steps_title_4': '第4步：软件下载',
        'process_steps_title_5': '第5步：登入账户',
        'process_steps_title_6': '第6步：使用现有账户登入',
        'process_steps_dec_text_1': '点击导航栏“网上开户”或点击右侧快捷导航栏“即时开户”提交申请资料',
        'process_steps_dec_text_2': '系统根据您所填写的开户数据进行自动审核，如审核失败请及时联系客服',
        'process_steps_dec_text_3': '资料审核成功后，工作人员会在24小时内，向您的邮箱或电话发送账户及密码',
        'process_steps_dec_text_4': '获取您的账户及密码后，点击本官网下载页面下载交易软件并安装',
        'process_steps_dec_text_5': '使用安装的交易软件及系统发送的账户密码登入您的账户',
        'process_steps_dec_text_6': '登入选项选择使用现有账户登入'
    },
    productInfo: {
        'product_title': '产品介绍',
        'product_dec_gold': '现货黄金',
        'product_dec_silver': '现货白银',
        'product_dec_rmb': '人民币公斤条',
        'product_gold_title': '产品介绍：现货黄金',
        'product_min_title_one': '现货黄金的由来',
        'product_gold_dec_1': '<p>伦敦是历史最悠久的黄金交易所，故现货黄金的另一个名称“伦敦金”亦由此而来现今主流的四个黄金交易中心包括国际黄金价格亦因以上四个交易中心而得以接轨，并提供24小时的黄金交易</p>',
        'product_min_title_two': '黄金的用途',
        'product_gold_dec_2': '<p>黄金自古以来已经被应用于货币、婚嫁饰物、国际储备以及各类工业用途在投资层面，近年黄金已渐渐发展成为主流投资产品，不再只是以往的保值和避险作用</p>',
        'influence_gold_price_title': '影响黄金价格因素',
        'influence_price_title_one': '影响一：美元强弱',
        'influence_price_title_two': '影响二：通货膨胀',
        'influence_price_title_three': '影响三：黄金需求',
        'influence_price_title_four': '影响四：各国政府政策',
        'influence_price_title_five': '影响五：突发事件（如战争）',
        'influence_gold_one_dec': '<p>美元跟黄金同为避险的其中一种工具，也能视为彼此间的竞争对手。</p><br/><p>资金往往会选择较强势的资产避险，当美元强势的时候，资金会从各类资产（包括黄金）流入美元，相反则会流出。</p><br/><p>故此黄金价格会与美元的强弱形成一个反比情况，当然亦会出现少数正比的情况。</p>',
        'influence_gold_two_dec': '<p>由于黄金被视为保值以及避险的作用，不少投资者皆会以黄金作为对抗通胀的一种投资产品，所以通胀亦会令黄金的价格上升。</p>',
        'influence_gold_three_dec': '<p>按照经济学的定义，当需求比供应更大时，就会带动价格上升。</p><p>黄金的供应难于扩大（因为开采难度，以及金矿的出产量），面对日渐增大的黄金需求，黄金的价格亦会因此而上升。</p>',
        'influence_gold_four_dec': '<p>近期各国政府皆推出各种货币量化宽松政策，货币亦因此而贬值，故此令到资金寻求保值的投资产品。</p><p>使黄金成为其中一种受到追捧的投资产品。</p>',
        'influence_gold_five_dec': '<p>各种突发事件，如战争，地震等都有机会令到当地政局不稳或经济受到影响，这会促使投资者买入黄金作避险。</p>',
        'product_silver_title': '产品介绍：白银的用途',
        'product_silver_min_title_one': '白银的用途',
        'product_silver_dec_1': '<p>白银以往是仅次于黄金的一种贵金属；</p><p>白银是古时货币的其中一种；</p><p>随着现今社会白银的重要性越来越低，白银已经不再视为货币金属；</p><p>基于其特性，良好的导电和导热，使白银成为了工业金属；</p><p>除了工业用途，白银亦被应用于各种不同的产品里，包括饰物，餐具，摄影器材及投资用途等等。</p>',
        'product_silver_influen_title': '影响白银价格因素',
        'product_silver_influen_one': '影响一：受到生产国每年生产的数量影响',
        'product_silver_influen_two': '影响二：通货膨胀',
        'product_silver_invest_title': '白银投资',
        'product_silver_invest_one': '高杠杆',
        'product_silver_invest_two': '灵活',
        'product_silver_invest_one_dec': '拥有比现货黄金更高的杠杆比例',
        'product_silver_invest_two_dec': '24小时双向交易让客户能把握每个财富增值时机',
        'rmb_kilo_title_one': '产品介绍：人民币公斤条',
        'rmb_kilo_min_title_one': '甚么是人民币公斤条',
        'rmb_kilo_title_one_dec_1': '<p>由于香港的人民币存款不断增加。据香港金融管理局数据显示人民币存款已约占香港总存款10%。但与此同时，离岸人民币产品仍相当缺乏。</p><br><p>国务院副总理李克强在十二五规划促进两地金融经贸合作时，为了推进人民币国际化进程，特批香港金银业贸易场推出全球首个离岸市场、以人民币计价黄金现货交易产品--人民币公斤条黄金。金银业贸易场在新闻稿中表示，新产品可帮助推动人民币国际化及香港人民币离岸中心发展，为投资者提供更多人民币投资产品选择，也可巩固香港作为世界主要黄金交易中心的地位。</p><br><p>人民币公斤条黄金在香港金银业贸易场设立及营运之自动对盘及交易系统内进行交易。金条规格与上海黄金交易所划一，是贸易场认可炼鑄商生产的9999成色公斤条，可透过贸易场电子交易系统交易。</p>',
        'rmb_kilo_title_two': '影响人民币公斤条价格因素',
        'rmb_kilo_title_two_dec_1': '<p>持仓成本影响人民币公斤条黄金的定价，若没有现货市埸供求的因素，人民币公斤条黄金的理论价等于买入相关现货黄金的成本。而现货市埸由实金供求为基础，与金融市埸以资金拆借成本定借贷供求的模式有所不同。人民币公斤条黄金的现货交割机制是上板交割实金时，交割双方在现货市埸上套取现金为考虑因素之一，另有意建立中立仓套取息差的行员将有意欲参与实金交割，间接影响现货市埸的供求。如仓费由持仓者支付予欠仓者，俗称「低息」。相反，如仓费由持仓者收取或欠仓者支付，则为「高息」。</p>',
        'rmb_kilo_min_title_two_1': '现货市场供求',
        'rmb_kilo_min_title_two_2': '持仓成本',
        'rmb_kilo_title_two_dec_2': '<p>人民币公斤条黄金价格将受现货市埸供求的变化所影响，再者，市埸情绪及参与行员亦是影响短期价格的因素，因此，人民币公斤条黄金的市埸价格不一定与相关市埸价格相同。</p>',
        'rmb_kilo_title_three': '人民币公斤条黄金特点',
        'rmb_kilo_title_three_min_title_one': '人民币报价及以人民币作合约结算',
        'rmb_kilo_title_three_min_title_one_dec1': '<p>民币报价及以人民币作合约结算，即实金交割清算。认可上海黄金交易所1号金（成色9999）或2号金（成色9995）及或贸易场认可黄金炼鑄商炼鑄之公斤条（成色9999），为一公斤合约。投资者可透过贸易场的会员进行买卖。</p>',
        'rmb_kilo_title_three_min_title_two': '采用现行电子交易平台提供人民币公斤条黄金',
        'rmb_kilo_title_three_min_title_two_dec1': '<p>采用现行电子交易平台提供人民币公斤条黄金，只提供已参与电子交易平台行员。所有透过贸易场电子交易平台进行之合约买卖均获贸易场派发独有的[合约交易编码]，以证明有关交易透过贸易场之电子交易平台进行，投资者更可以凭借有关[合约交易编码]于贸易场网站查阅交易数据，大大提高投资黄金的透明度，以保障投资者的利益。</p>',
        'rmb_kilo_title_four': '投资盛大金业人民币公斤条黄金优势',
        'rmb_kilo_title_four_min_title_one': '低门槛',
        'rmb_kilo_title_four_min_title_one_dec': '最低交易量0.5张合约，1,500人民币即可进行交易（盛大金业每张合约需要3000人民币保证金）',
        'rmb_kilo_title_four_min_title_two': '灵活',
        'rmb_kilo_title_four_min_title_two_dec': '24小时双向交易让客户能把握每个财富增值时机',
        'transact_table_td_1': '本地现货金(LLG)',
        'transact_table_td_2': '本地现货白银(LLS)',
        'transact_table_td_3': '合约单位(每手)',
        'transact_table_td_4': '100盎司',
        'transact_table_td_5': '5000盎司',
        'transact_table_td_6': '交易差价',
        'transact_table_td_7': '0.50美元/盎司',
        'transact_table_td_8': '0.05美元/盎司',
        'transact_table_td_9': '基本保证金',
        'transact_table_td_10': '每手2500美元',
        'transact_table_td_11': '单笔最低交易数量',
        'transact_table_td_12': '0.1手合约',
        'transact_table_td_13': '单笔最大交易数量',
        'transact_table_td_14': '10手合约',
        'transact_table_td_15': '手续费(每手)',
        'transact_table_td_16': '50美元',
        'transact_table_td_17': '每日利息',
        'transact_table_td_18': '买入：-1.75%；卖出：-1.25%(此处为年利率)，按市场决定',
        'transact_table_td_19': '每日仓租',
        'transact_table_td_20': '不适用',
        'transact_table_td_21': '锁仓保证金',
        'transact_table_td_22': '625美元 (一套1250美元)',
        'transact_time_end_title': '交易时间及结算时间',
        'transact_time_table_td_1': '夏令',
        'transact_time_table_td_2': '冬令',
        'transact_time_table_td_3': '交易时间',
        'transact_time_table_td_4': '由星期一上午07:01至星期六凌晨03:59',
        'transact_time_table_td_5': '由星期一上午07:01至星期六凌晨03:59',
        'transact_time_table_td_6': '结算时间',
        'transact_time_table_td_7': '每日香港时间凌晨五时至六时正',
        'transact_time_table_td_8': '每日香港时间凌晨六时至七时正',
        'transact_time_table_td_9': '美国冬令时间由十一月第一个星期日早上二时至三月第二个星期日早上二时；',
        'transact_time_table_td_10': '美国夏令时间由三月第二个星期日早上二时至十一月第一个星期日早上二时。',
        'transact_time_table_td_11': '交易时将会按国际假期更改，如有更动将会于本公司网页公布',
        'transact_time_table_td_12': '持仓过市星期五，六，日，需付三天利息',
        'transact_mode_max_title': '交易方式',
        'transact_mode_title_one': '市价单',
        'transact_mode_title_two': '限价单',
        'transact_mode_title_three': '止盈单及止损单',
        'transact_mode_one_dec_1': '以当时市场价格进行交易，如遇上市况波动，市价单有可能不会成交',
        'transact_mode_two_dec_1': '现货黄金限价单需要与市场价格相距最少300个价位（即3美元）或以上才能设定，现货白银限价单需要与市场价格相距最少30个价位（即0.3美元）或以上才能设定',
        'transact_mode_two_dec_2': '* 若客户交易帐号内的保证金不足提交限价单不会成交，并会即时取消处理',
        'transact_mode_three_dec_1': '可为仍未平仓的合约设定，现货黄金需要300个价位以上才能设定，现货白银需要价格30个价位以上才能设定',
        'transact_mode_three_dec_2': '* 所有限价单，止盈单，止损单有效时间直至当周收市时间或假期收市前，除非已成交或客户自行取消',
        'transact_force_title_one': '强制平仓',
        'transact_force_title_two': '异常交易',
        'transact_force_title_three': '跳空规则',
        'transact_force_title_one_dec': '<p>当交易帐号内的净值低于保证金50%或以下，客户将被要求追加预付款至基本预付款比例。当交易帐号内的净值低于保证金要求的20%或以下，为保障客户利益，本公司将会为客户持单部分合约或全部合约平仓，直至净值回到保证金要求的20%以上</p>',
        'transact_force_title_two_dec': '<p>1、如因网络延迟，故障，电脑故障，报价误差或报价系统漏洞，均有可能造成交易平台上的报价无法准确地反映即时市场价格，为维护网络交易的公平性，盛大金业并不接受任何利用故障或漏洞进行之交易，如经发现会将所有有关交易取消并追回，所有非法利润及其所产生的额外费用</p><p>2、如当中有30%的订单持仓时间低于3分钟，或属于3分钟内建立的锁仓订单，账户会被判定为交易异常</p><p>★ 交易单亏损額达到交易本金10%或以上，不作任何处理，将客户的取款金额发放给客户并会销户处理</p><p>★ 交易单亏损額低于交易本金10%，我们会收取注资金额的10%作为异常交易产生的成本费用，再将余额发放给客户并会销户处理。</p><p>★ 审核周期内的交易单是盈利的，我们会扣除所有盈利并会收取注资金额的10%作为异常交易产生的成本费用，再将余额发放给客户并会销户处理。</p>',
        'transact_force_title_three_dec': '<p>在一般跳空情况下，所有限价单将根据客户所订立的价格成交，如遇上客户同时存在未平仓合约及限价单，跳空导致保证金不足，持有仓位会被斩仓及限价单被取消，盛大金业保留对客户的以上情况的最终审批权</p>'
    },
    platformAdvant: {
        'product_advant_title_one': '优势一：低门槛',
        'product_advant_title_two': '优势二：双向交易',
        'product_advant_title_three': '优势三：高杠杆',
        'product_advant_title_four': '优势四：投资便捷',
        'product_advant_one_dec': '最低可交易0.1手，资金低，为更广泛的投资者创造了小资金、低门坎的入门机会。',
        'product_advant_two_dec': '交易现货黄金和现货白银可做多或做空，黄金价格或白银价格上涨可做多盈利，相反下跌则可做空盈利，无论升市或跌市均有投资获利机会。',
        'product_advant_three_dec': '投入资金少，高杠杆，高回报。伦敦金交易实行保证金制度，金价每波动1美元，一手就有100美元的收益，以小博大，更有效的利用资金，放大投资回报率。',
        'product_advant_four_dec': 'MF4交易平台24小时随时交易。伦敦、纽约、香港等全球黄金市场交易时间连成一体，构成一个24小时无间断的投资交易系统，客户通过MF4电子交易系统进行24小时交易。',
        'access_advant_title_one': '优势一：存款即时到帐',
        'access_advant_title_two': '优势二：24小时取款',
        'access_advant_title_three': '优势三：公平货币兑换',
        'access_advant_one_dec': '银联24小时在线入金，即时入账到MF4交易帐户，方便客户在波动的市场作出即时的资金调配，捕捉每一个获利机会或避免损失。',
        'access_advant_two_dec': '客户可随时透过完善的网上用户中心，提取帐户内的资金，方便客户灵活调配资金。',
        'access_advant_three_dec': '按照银行公布的货币兑换汇率，并在官网发报最新汇率，提高兑换透明度，保证货币兑换公平，公正，清晰。',
        'reput_advant_title_one': '优势一：信心保证',
        'reput_advant_title_two': '优势二：交易公平、公正、公开',
        'reput_advant_title_three': '优势三：交易平台迅速及稳定',
        'reput_advant_one_dec': '盛大金业是香港金银业贸易场会员第162号行员，是香港金银业贸易场认可实金买卖商及提供电子交易商。',
        'reput_advant_two_dec': '下单价格均按国际黄金市场为准，确保交易公平、公正、公开',
        'reput_advant_three_dec': '盛大金业现正使用多年来广授国际品牌移动财经(MF4)交易软件，主要是因为MF4交易平台稳定，交易迅速及易学易用，确保客户交易简便、迅速及稳定。'
        
    },
    platDownload: {
        'trand_platform_title': '盛大交易平台',
        'trand_plat_dec': '电脑端软件在线下载',
        'download_dec_one': '点击此处下载',
        'download_dec_one_1': '点击下载Windows版',
        'download_dec_two': '备用下载地址',
        'download_dec_text': '若以上通道无法下载，可选择以下备用通道',
        'download_iphone_text': 'iphone版扫码下载',
        'download_android_text': 'Android版扫码下载'
    },
    aboutIntroduct: {
        'introduct_title': '盛大金业简介',
        'introduct_dec_content': '香港盛大金业有限公司，为香港金银业贸易场第162号行员，属于香港金银业贸易场认可实金购买卖商。盛大金业并提供24小时伦敦金、银网络交易，各种专业、快捷、准确信息。为客户提供专业服务团队，24小时客服解答客户交易问题。致力提供稳定、公平、公正的交易平台。专业优秀服务团队以客为本，务求满足客户的投资需求。成为业界内其中一间最优秀的黄金投资企业，树立良好形象，获取广大客户爱护及信任。',
        'introduct_charact_1': '核心技术',
        'introduct_charact_2': '金融服务',
        'introduct_charact_3': '专业机构',
        'introduct_charact_4': '全球交易者'
    },
    processInfo: {
        'domestic_car_title': '国内卡存款',
        'domestic_car_proces_one': '在盛大金业网站登录',
        'domestic_car_proces_two': '于网站内的入金信息选择国内卡存款',
        'domestic_car_proces_three': '使用国内卡存款并”需要”提交单据截图',
        'domestic_car_proces_four': '使用国内卡存款方法将会豁免银联存款手续费',
        'deposit_car_title': '香港银行卡存款/电汇',
        'deposit_car_proces_one': '存款到盛大金业香港银行户口',
        'deposit_car_proces_two': '存款完成后，单据截图请以电邮/传真/QQ等方式提交到盛大金业客户服务部',
        'deposit_car_proces_three': '假若客户是以电汇形式进行存款，存款时间会因应各地银行而有所不同',
        'deposit_car_proces_four': '确认资金到帐后，资金将会立即存到交易帐户，客户可即时进行交易',
        'bank_info_title': '存款银行资料',
        'company_name_title': '公司名称',
        'company_name_info': '盛大金业有限公司',
        'company_address_title': '公司地址',
        'company_address_info': '香港铜锣湾时代广场一座45楼',
        'bank_address_title': '银行地址',
        'bank_address_info': '香港中环皇后大道中161号',
        'bank_name_info': '银行名称',
        'bank_title_account_info': '账户名称',
        'bank_account_info': '银行账号',
        'bank_swift_code_info': 'SWIFT',
        // 'bank_address_info': '银行地址',
        'bank_name_info_1': '华侨永亨银行',
        'bank_title_account_info_1': '盛大金业有限公司',
        // 'bank_address_info_1': '永亨网上转账 - Maker 程俊彦 / Authorizer 林霆锋',
        'online_process_title_one': '亲身办理',
        'online_process_title_two': '网上提交出金申请',
        'online_process_title_three': '邮寄/电邮/QQ',
        'online_process_title_one_dec': '客户可以在盛大金业办公时间内亲临本公司提交出金申请',
        'online_process_title_two_dec': '客户只需使用盛大金业所提供的网上帐号及密码登陆盛大金业网站，即可透过网站提交出金申请，本公司在核实数据无误后，保证资金1小时内到帐',
        'online_process_title_three_dec': '客户可以将已签署及填写出金金額的申请表，以邮寄/电邮/QQ形式提交到盛大金业',
        'online_process_precaution_title': '注意事项：',
        'online_process_precaution_dec_1': '<p>1、盛大金业只接受客户本人之名义存款及提取资金，不接受第三方入金以及提款至第三方帐户</p><br><p>2、为客户能尽早提取资金，请核实阁下的银行帐户数据是否正确无误</p><br><p>3、每个工作日递交提取资金申请的截止时间为下午4时30分，逾时之申请将会在下一个工作天处理</p><br><p>4、客户申请取款，收款银行可能收取转账所需之行政费，一切手续费均会从提款中扣除</p><br><p>5、客户申请取款后，若发现有任何问题请尽快联络客服部门查询</p><br><p>6、盛大金业将有以下措施防范不法份子：</p><p>客户帐号出金金额中有50%不曾用于建仓交易或最后一次存款后未有进行建仓交易，取款时将被收取6%手续费。客户完成入金后，申请出金金额时达到以下交易手数可免除出金手续费：</p>',
        'domestice_card_title': '现货黄金/白银/人民币公斤条',
        'domestice_card_dec_1': '为回馈盛大金业客户，盛大金业将由2021年4月1日起，豁免银联存款手续费。客户帐号旧有的信用額则按照原有的规则回赠。',
        'domestice_terms_title': '条款及细则：',
        'domestice_terms_dec_1': '<p>1、只适用于透过国内银行卡注入的资金</p><br><p>2、盛大金业有权利随时修改或终止此优惠活动</p><br><p>3、如有任何争议，盛大金业拥有最终决定权</p>'
    },
    contactUsInfo: {
        'contact_company_max_title': '香港盛大金业有限公司',
        'contact_business_title': '商务拓展部',
        'contact_business_email': 'cs@sdggex.com (3个工作日内回复)',
        'contact_business_qq': '852-37011110 (9:30-18:30)',
        'contact_business_address': '香港铜锣湾时代广场一座45楼',
        'contact_market_title': '市场品牌部',
        'contact_market_email': 'cs@sdggex.com (3个工作日内回复)',
        'contact_market_qq': '852-37011117 (9:30-18:30)',
        'contact_market_address': '香港铜锣湾时代广场一座45楼',
        'contact_customer_title': '客服',
        'contact_customer_email': 'cs@sdggex.com (3个工作日内回复)',
        'contact_customer_qq': '852-37011117 (9:30-18:30)',
        'contact_customer_address': '香港铜锣湾时代广场一座45楼',
        'contact_compay_address': '香港铜锣湾时代广场一座45楼'
    },
    accountInfo: {
        account_min_title: '24小时开户/立即开启投资之旅',
        account_name_info: '真实姓名',
        account_identity_card: '身份证号码',
        account_sex: '性别',
        account_sex_1: '男',
        account_sex_2: '女',
        account_phone_number: '手机号码',
        account_phone_area: '手机区号',
        account_card_front: '身份证副本（正面）',
        account_upload_file: '上传文件',
        account_card_hold: '手持身份证照片',
        account_photo_text: '（身份证放在白纸上方，白纸上写上仅供盛大金业开户使用，并写上开户当天的日期，例如：2018年1月1日。选择上传文件大小在3M内，上传文件格式为：JPG/PNG）',
        account_email: '电子邮箱',
        account_bank_number: '银行卡号',
        account_bank_deposit: '开户银行',
        account_bank_branch: '支行',
        account_bank_copy: '银行卡副本（正面）',
        account_referen_number: '介绍人编号',
        accout_verif_method: '验证方式',
        account_eamil_verficat: '电子邮箱验证',
        account_graphic_code: '图形验证码',
        account_open_verfit_code: "开户验证码",
        account_agreement_text_1: '我已阅读并同意',
        account_agreement_text_2: '【隐私条款】',
        account_agreement_text_3: '【免责声明】',
        account_agreement_text_4: '【风险声明】',
        account_agreement_text_5: '【客户协议】',
        account_submit_btn_info: '立即提交'
    },
    verificationInfo: {
        verificat_rule_upload: '未上传',
        rule_get_verifit_code: '获取验证码',
        rule_attachment_upload: '已上传附件',
        rule_read_text: '请勾选已阅读并同意协议',
        rule_loading_text: '正在加载...',
        rule_audit_success: '提交成功，工作人员将会在1~2个工作日内审核。',
        rule_verificat_name: '请输入真实姓名',
        rule_verificat_card_no: '请输入身份证号码',
        rule_verificat_phone_number: '请输入手机号码',
        rule_verificat_email: '请输入电子邮箱',
        rule_bank_card_number: '请输入银行卡号',
        rule_bank_address: '请输入开户银行地址',
        rule_bank_branch_name: '请输入开户银行支行名字',
        rule_reference_number: '请输入介绍人编号',
        rule_account_open_code: '请输入开户验证码',
        rule_graphic_code: '请输入图形验证码',
        rule_upload_card: '请上传身份证副本(正面)',
        rule_upload_hold_card: '请上传手持身份证照片',
        rule_upload_bank_card: '请上传银行卡副本(正面)',
        rule_graphic_code_empty: '图形验证码不能为空，请输入图形验证码',
        rule_email_empty: '邮箱不能为空，请输入邮箱！',
        rule_area_empty: '手机区号不能为空，请选择手机区号！',
        rule_phone_empty: '手机号码不能为空，请输入手机号码！',
        rule_tips_text: '提示',
        rule_sure_btn: '确定'
    },
    moreInfo: {
        'more_info': '了解更多'
    },
    agreementFile: {
        'privacy_clause_file': '/static/agreementFile/cn/隐私条款.pdf', // 隐私条款协议
        'disclaimer_file': '/static/agreementFile/cn/免责声明.pdf', // 免责申明协议
        'risk_statement_file': '/static/agreementFile/cn/风险声明.pdf', // 风险申明协议
        'customer_agreement_file': '/static/agreementFile/cn/客户协议.pdf' // 客户协议
    },
    ...zhLocale
}

export default cn